import Vue from 'vue'
import App from './App.vue'
import router from './application/router'
import store  from './application/vuex/store'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '../static/css/reset.css'//重置样式文件
//调试模式
Vue.config.productionTip = false;
//vant 插件库
import Vant from 'vant';
import 'vant/lib/index.css'; //vant样式
import { Area, Popup } from 'vant';
Vue.use(Area);
Vue.use(Popup);
import ElementUI from 'element-ui';  //引入elementui组件库
Vue.use(ElementUI); //导入elementui插件
import 'element-ui/lib/theme-chalk/index.css';//引入elementui组件样式

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    ak: '9g14qnPgjGrOgdsXnrP8iIXdPC2OyB6O'  //  在此输入你自己的百度地图ak
})
import 'babel-polyfill'
import Es6Promise from 'es6-promise'

require('es6-promise').polyfill();
Es6Promise.polyfill();



//所有请求API集合
import HttpRequest from './application/api'
import config from './application/axios/config'


//方法挂载到Vue类的原型上
Vue.prototype.$http = new HttpRequest;
Vue.prototype.$config = config;

//注入插件
Vue.use(Vant);
router.afterEach((to,from,next) => {
    window.console.log(to,from,next)
    window.scrollTo(0,0);
});

window.vm = new Vue({
    router,
    store,
    render: h => h(App),
    created() {

    },
    mounted() {

    }
}).$mount('#app');

